import { z } from 'zod'
import type { IntlShape } from 'react-intl'
import { numberField } from 'util/zodSchemas'

export const chartOfAccountBaseSchema = z.object({
	uuid: z.string().uuid(),
	createdAt: z.date().optional().nullable(),
	updatedAt: z.date().optional().nullable(),
	show: z.boolean(),
	number: z.number(),
	companyUUID: z.string().uuid(),
	name: z.string(),
	accountingInstructions: z.string().optional(),
	alvHandling: z.string().optional(),
	alvPercentage: z.string().optional(),
	accountType: z.string(),
	openingBalance: z.number().optional(),
})

export const createChartOfAccountSchema = (intl: IntlShape) => {
	const s = chartOfAccountBaseSchema

	const requiredError = intl.formatMessage({
		defaultMessage: 'Kenttä vaaditaan.',
		description: 'Error message for required field',
	})

	return s
		.omit({
			uuid: true,
			createdAt: true,
			updatedAt: true,
		})
		.extend({
			number: numberField(intl, {
				required: { value: true },
				allowNegative: { value: false },
			}),
			name: s.shape.name.min(1, {
				message: requiredError,
			}),
			accountingInstructions: s.shape.accountingInstructions
				.optional()
				.nullable(),
			alvHandling: s.shape.alvHandling.optional().nullable(),
			alvPercentage: s.shape.alvPercentage.optional().nullable(),
			accountType: s.shape.accountType.min(1, {
				message: requiredError,
			}),
			openingBalance: numberField(intl, {
				required: { value: false },
				allowNegative: { value: false },
			}),
		})
}

export type ChartOfAccount = z.infer<typeof chartOfAccountBaseSchema>
export type CreateChartOfAccount = Omit<
	ChartOfAccount,
	'uuid' | 'createdAt' | 'updatedAt'
>

export type TalousChartOfAccount = {
	id: number
	parent: string
	code: string
	name: string
	default: number
	plus: number
	state: number
	vat: number
	groupId: number
	groupName: string
	databaseSource: string
}

export type CreateTalousChartOfAccount = Omit<
	TalousChartOfAccount,
	'id' | 'default' | 'plus' | 'state' | 'databaseSource'
>
